import LandingPage from "feature/common/landing/landing-page";

export default LandingPage
